// frontend/src/App.tsx
import { useIsAuthenticated } from '@azure/msal-react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import LessonPage from './pages/LessonPage';
import LessonHistoryPage from './pages/LessonHistoryPage';
import AdminLessonsPage from './pages/AdminLessonsPage';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import LessonDetail from './pages/LessonDetail';
import ChallengeDetailPage from './pages/ChallengeDetailPage';
import ChallengePage from './pages/ChallengePage';
import Team from './pages/Team';
import Analytics from './pages/Analytics';
import AssessmentsPage from './pages/AssessmentsPage';
import AssessmentTakingPage from './pages/AssessmentTakingPage';
import AssessmentResultsPage from './pages/AssessmentResultsPage';
import SkillsDashboard from './pages/SkillsDashboard';
import RoleSelectionPage from './pages/RoleSelectionPage';
import AssessmentCompletionPage from './pages/AssessmentCompletionPage';
import AdminAssessmentResultsPage from './pages/AdminAssessmentResultsPage';

function App() {
  const msalAuthenticated = useIsAuthenticated();
  const isAuthenticated = msalAuthenticated;

  if (!isAuthenticated) return <Login />;

  return (
    <BrowserRouter>
      <div className="flex h-screen text-white">
      {/* bg-gray-100 */}
        <Sidebar />
        <div className="flex flex-col flex-1 lg:ml-0">
          <Header />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/challenges" element={<ChallengePage />} />
            <Route path="/challenges/:challenge_id" element={<ChallengeDetailPage />} />
            <Route path="/challenges/:challenge_id/lessons/:lesson_id" element={<LessonDetail />} />
            <Route path="/lessons" element={<LessonPage />} />
            <Route path="/lessons/:lesson_id" element={<LessonDetail />} />
            <Route path="/history" element={<LessonHistoryPage />} />
            <Route path="/team" element={<Team />} />
            <Route path="/role-selection" element={<RoleSelectionPage />} />
            <Route path="/assessments" element={<AssessmentsPage />} />
            <Route path="/assessments/:assessmentId" element={<AssessmentTakingPage />} />
            <Route path="/assessments/:assessmentId/completed" element={<AssessmentCompletionPage />} />
            <Route path="/assessments/:assessmentId/results/:attemptId" element={<AssessmentResultsPage />} />
            <Route path="/skills" element={<SkillsDashboard />} />
            <Route path="/admin/lessons" element={<AdminLessonsPage />} />
            <Route path="/admin/assessment-results" element={<AdminAssessmentResultsPage />} />
            <Route path="*" element={<Dashboard />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
